import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pconsAdminState'
})
export class PconsAdminStatePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    switch (value) {
      case 'LOCKED':
        return '<div class="center-content" title="Locked"><i class="fa fa fa-lock"></i></div>';
      case 'LOCKED_INCOMING':
        return '<div class="space-between" title="Locked for incoming"><i class="fa fa-arrow-right"></i><i class="fa fa-lock"></i></div>';
      case 'LOCKED_OUTGOING':
        return '<div class="space-between" title="Locked for outgoing"><i class="fa fa-arrow-left"></i><i class="fa fa-lock"></i></div>';
      default:
        return '<div class="center-content" title="Unlocked"><i class="fa fa-unlock"></i></div>';
    }
  }

}
